import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI from "../../utils/axios";

export const verifyEmail = createAsyncThunk(
  "email/verifyEmail",
  async ({ email, otp }, thunkAPI) => {
    try {
      const response = await fetchAPI.post("/email/verifyEmail", { email, otp });
      return response.data;
    } catch (err) {
      const message = err?.response?.data?.error || "Failed to verify email";
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const resendVerification = createAsyncThunk(
  "email/resendVerification",
  async ({ email }, thunkAPI) => {
    try {
      const response = await fetchAPI.post("/email/resendVerification", { email });
      return response.data;
    } catch (err) {
      const message = err?.response?.data?.error || "Failed to resend verification";
      return thunkAPI.rejectWithValue(message);
    }
  }
);
